import type { Player } from './player.type';
import type { MapData, MapNode } from './map.type';
import { createDie } from './die.type';
import type { Events, EventType } from './eventList';
import type { DieFace } from './face.type';

export type MapEvent = {
  title: string;
  id: Events;
  text: string;
  type: EventType;
  image: string;
  step: Step;
};

export type Step = {
  text: string;
  subtext?: string;
  image?: string;
  options: Array<Option>;
};

export type Condition = {
  text?: string;
  icon?: string;
  fulfils: (player: Player) => boolean;
};

export type Option = {
  text: string;
  subtext?: string;
  condition?: Condition;
  activate?:
    | ((player: Player, map: MapData, node: MapNode) => void)
    | Array<(player: Player, map: MapData, node: MapNode) => void>;
  next?: Step | Array<Step>;
};

/**
 * Every face of every die the player owns. A single face can carry more than one
 * symbol, so this is an array OF faces, each of which is an array of symbols.
 */
export const getPlayerAttributes = (player: Player): Array<DieFace[]> => {
  const faces: Array<DieFace[]> = [];

  player.dice.forEach((die) => {
    createDie(die).faces.forEach((face: DieFace[]) => {
      faces.push(face);
    });
  });

  return faces;
};

/** True when any face of any of the player's dice shows `attribute`. */
export const playerHasAttribute = (player: Player, attribute: DieFace) => {
  return getPlayerAttributes(player).some((face) => face.includes(attribute));
};

export const createHasCondition = (attribute: DieFace): Condition => {
  return {
    text: '', //`Has ${attribute} die`,
    icon: attribute,
    fulfils: (player: Player) => {
      return playerHasAttribute(player, attribute);
    },
  };
};
